import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content-edit-page" }
const _hoisted_2 = { class: "action-topbar-card" }
const _hoisted_3 = { class: "bar-left" }
const _hoisted_4 = { class: "icon-avatar" }
const _hoisted_5 = { class: "text-group" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "bar-right" }
const _hoisted_8 = { class: "map-type-select" }
const _hoisted_9 = { class: "workbench-layout" }
const _hoisted_10 = { class: "level-list-panel" }
const _hoisted_11 = { class: "panel-header" }
const _hoisted_12 = { class: "panel-title-box" }
const _hoisted_13 = { class: "level-count-badge" }
const _hoisted_14 = { class: "draggable-list-container" }
const _hoisted_15 = { class: "level-badge" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "level-name" }
const _hoisted_18 = { class: "action-icons" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "empty-level-box"
}
const _hoisted_22 = { class: "map-preview-panel" }
const _hoisted_23 = { class: "map-panel-header" }
const _hoisted_24 = { class: "map-title-txt" }
const _hoisted_25 = { class: "map-viewport-card" }
const _hoisted_26 = {
  key: 0,
  class: "map-container-wrap"
}
const _hoisted_27 = {
  key: 1,
  class: "custom-canvas-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Guide = _resolveComponent("Guide")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_DocumentChecked = _resolveComponent("DocumentChecked")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_MapContainer = _resolveComponent("MapContainer")!
  const _component_Cavan = _resolveComponent("Cavan")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_draggable = _resolveDirective("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Guide)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("Content.contentEdit") || "关卡编排与全局地图配置"), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sub-text" }, "拖拽关卡卡片可快速调整玩家闯关顺序，右侧可配置地图类型与初始坐标", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "select-label" }, "地图底图引擎", -1)),
          _createVNode(_component_el_select, {
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            placeholder: "选择地图类型",
            class: "map-select-box"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "save-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.value === '自定义地图' ? _ctx.saveContent() : _ctx.saveContent2()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentChecked)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Content.save") || "保存配置"), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            lg: 10
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "panel-title" }, "关卡列表", -1)),
                    _createElementVNode("span", _hoisted_13, "共 " + _toDisplayString(_ctx.list2.length) + " 关", 1)
                  ]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "add-level-btn",
                    icon: _ctx.Plus,
                    onClick: _ctx.addLevel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Content.addLevel") || "新建关卡"), 1)
                    ]),
                    _: 1
                  }, 8, ["icon", "onClick"])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "level-item-card",
                      key: item.levelId || item.id
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", {
                        class: "drag-handle",
                        title: "按住拖拽排序"
                      }, [
                        _createElementVNode("span", { class: "dot" }),
                        _createElementVNode("span", { class: "dot" }),
                        _createElementVNode("span", { class: "dot" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(index + 1), 1),
                      _createElementVNode("div", {
                        class: "level-info",
                        onClick: ($event: any) => (_ctx.toEditLevel(item.levelId))
                      }, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.name || `关卡 ${index + 1}`), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "level-hint" }, "点击进入详细关卡谜题配置", -1))
                      ], 8, _hoisted_16),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_el_tooltip, {
                          content: "编辑关卡",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "icon-btn edit-btn",
                              onClick: _withModifiers(($event: any) => (_ctx.toEditLevel(item.levelId)), ["stop"])
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EditPen)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_19)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_tooltip, {
                          content: "删除关卡",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "icon-btn del-btn",
                              onClick: _withModifiers(($event: any) => (_ctx.deleteLevel(item.levelId)), ["stop"])
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DeleteFilled)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_20)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 128)),
                  (_ctx.list2.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_el_icon, { class: "empty-icon" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoFilled)
                          ]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, "暂无配置关卡，请点击上方按钮新建", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_draggable, [
                _ctx.list2,
                {
                  animation: 150,
                  onUpdate: _ctx.onUpdate,
                  onStart: _ctx.onStart,
                  handle: '.drag-handle',
                },
              ]]
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            lg: 14
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "map-status-dot" }, null, -1)),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.value) + " · 坐标拾取与路线标记", 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.value === '高德地图')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_MapContainer, {
                          onChangePos: _ctx.changePos,
                          long: _ctx.long,
                          lat: _ctx.lat
                        }, null, 8, ["onChangePos", "long", "lat"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.value === '自定义地图')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_Cavan, {
                          ref: "Cav",
                          imgUrl: _ctx.CavImg
                        }, null, 8, ["imgUrl"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
  ]))
}